

export class Emitter {
  constructor() {
    const delegate = document.createDocumentFragment();
    this.addEventListener = delegate.addEventListener.bind(delegate);
    this.removeEventListener = delegate.removeEventListener.bind(delegate);
    this.dispatchEvent = delegate.dispatchEvent.bind(delegate);
  }
}



// WEBPACK FOOTER //
// ./assets/es6/common/emitter.es6